import Vue from 'vue';
import VueSimplePopup from '@telexpress/vue-simple-popup';

Vue.use(VueSimplePopup);
